import React from 'react';

/**
 * AddSlideModal — choose whether to add a blank slide or one from a template.
 *
 * Props:
 *  - open          : boolean
 *  - themes        : array of SocialTheme
 *  - onAddBlank    : () => void
 *  - onAddFromTheme: (themeId) => void
 *  - onClose       : () => void
 */
export default function AddSlideModal({ open, themes = [], onAddBlank, onAddFromTheme, onClose }) {
  if (!open) return null;

  return (
    <div className="tw-fixed tw-inset-0 tw-z-50 tw-flex tw-items-center tw-justify-center tw-bg-black/60 tw-backdrop-blur-sm">
      <div className="tw-bg-zinc-900 tw-border tw-border-zinc-700 tw-rounded-2xl tw-p-6 tw-w-full tw-max-w-md tw-shadow-2xl tw-max-h-[80vh] tw-overflow-y-auto">
        <h3 className="tw-text-sm tw-font-bold tw-text-white tw-mb-4">Add New Slide</h3>

        <button
          onClick={() => { onAddBlank(); onClose(); }}
          className="tw-btn-secondary tw-w-full tw-text-xs tw-mb-4"
        >
          ➕ Blank Slide
        </button>

        {themes.length > 0 && (
          <>
            <div className="tw-text-[10px] tw-font-bold tw-text-zinc-500 tw-uppercase tw-tracking-widest tw-mb-3">
              From Template
            </div>
            <div className="tw-grid tw-grid-cols-2 tw-gap-3">
              {themes.map((theme) => {
                const gradient =
                  theme.gradientColors?.length >= 2
                    ? `linear-gradient(${theme.gradientDirection || 'to bottom'}, ${theme.gradientColors[0]}, ${theme.gradientColors[1]})`
                    : theme.gradientColors?.[0] || '#333';

                return (
                  <button
                    key={theme._id}
                    onClick={() => { onAddFromTheme(theme._id); onClose(); }}
                    className="tw-rounded-xl tw-border tw-border-zinc-700 tw-bg-zinc-900 hover:tw-border-zinc-500 tw-p-3 tw-transition-all tw-text-left"
                  >
                    <div
                      className="tw-h-12 tw-rounded-lg tw-mb-2 tw-flex tw-items-center tw-justify-center"
                      style={{ background: gradient }}
                    >
                      <span
                        className="tw-text-xs tw-font-black tw-uppercase"
                        style={{ color: theme.textColor || '#fff' }}
                      >
                        Aa
                      </span>
                    </div>
                    <div className="tw-text-[10px] tw-font-bold tw-text-zinc-400 tw-uppercase tw-tracking-wider tw-truncate">
                      {theme.name}
                    </div>
                  </button>
                );
              })}
            </div>
          </>
        )}

        <button onClick={onClose} className="tw-btn-secondary tw-w-full tw-text-xs tw-mt-4">
          Cancel
        </button>
      </div>
    </div>
  );
}
